import './_main-navigation.scss';
import mainNavigation from './main-navigation';

window.nn.registerModule('mainNavigation', (element) => {
  const app = new mainNavigation(element);
  return app.init();
});